<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6 order-md-2">
                    <b-carousel
                        id="carousel1"
                        class="img-fluid floating"
                        controls
                        indicators
                    >
                        <!-- Text slides with image -->
                        <b-carousel-slide img-src="img/theme/zeroWaste.png"></b-carousel-slide>
                        <b-carousel-slide img-src="img/theme/zeroWaste2.png"></b-carousel-slide>
                    </b-carousel>
                </div>
                <div class="col-md-6 order-md-1">
                    <div class="pr-md-5">
                        <icon
                            name="ni ni-settings-gear-65"
                            class="mb-5"
                            size="lg"
                            type="primary"
                            shadow
                            rounded
                        ></icon>
                        <h3 class="text-uppercase">Nos contenants</h3>
                        <p class="text-justify">
                            Tous nos bacs et silos proviennent de Zero Waste Dispenser (en Belgique, désolé on n'a pas trouvé la même chose en France...).
                            Notre choix s'est porté sur ces modèles pour la bonne et simple raison qu'ils n'étaient pas en plastique et ainsi en cohérence
                            avec la réduction de plastique dans notre épicerie.
                        </p>
                        <ul class="list-unstyled mt-5">
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge
                                        type="primary"
                                        circle
                                        class="mr-3"
                                        icon="ni ni-settings-gear-65"
                                    ></badge>
                                    <h6 class="mb-0">Matériaux durables</h6>
                                </div>
                            </li>
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge
                                        type="primary"
                                        circle
                                        class="mr-3"
                                        icon="ni ni-atom"
                                    ></badge>
                                    <h6 class="mb-0">Ergonomiques</h6>
                                </div>
                            </li>
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge
                                        type="primary"
                                        circle
                                        class="mr-3"
                                        icon="ni ni-satisfied"
                                    ></badge>
                                    <h6 class="mb-0">Hygiéniques</h6>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BCarousel from 'bootstrap-vue/es/components/carousel/carousel'
import BCarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide'
export default {
  name: '',
  components: {
    BCarousel,
    BCarouselSlide,
  },
}
</script>